import React from 'react' // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types'
import { utils, settings } from 'parking-react-common'
import 'balloon-css/balloon.min.css'

import Tooltip from './Tooltip'


const TZDateTime = ({ input }) => {
    const dateTime = utils.formatTZDateTime(input)
    const dateTimeWithTZ = utils.formatTZDateTime(input, settings.TZ_DATETIME_FORMAT)

    return (
        <Tooltip title={ dateTimeWithTZ } position="up">
            { dateTime }
        </Tooltip>
    )
}

TZDateTime.propTypes = {
    input: PropTypes.string
}


export default TZDateTime
